const clients = [
  "Nike", "Coca-Cola", "PepsiCo", "KFC", "Nestlé", "Samsung", "LG", "Vodafone", "Orange",
  "Etisalat", "Schweppes", "Toshiba", "Hardee's", "Under Armour", "Hyundai Middle East",
  "Americana", "Speedo Canada", "Toronto Raptors", "Edita", "Ariel", "Emaar Misr", "Sodic",
  "Palm Hills", "Mountainview", "The Royal Commission of AlUla", "King Fahd Causeway", "GOSI",
  "Al-Ahly SC", "Grand Egyptian Museum", "Orascom Construction Industries", "Orascom Developments",
  "Saudi Ministry of Interior", "Ministry of Haj and Umrah", "Saudi Tourism", "Saudi Diwan",
  "Saudi Real-Estate Company", "Ontario Hockey Association", "Ontario Ministry of Education",
  "Subaru", "Rexona", "Chipsy", "Tiger", "Swan Lake", "Tornado", "El-Araby Group", "Freska",
  "Crunchy", "Bo Island", "Eco Maxim", "Eco West", "West Development", "Xtreme Couture",
  "MMA North America", "DanceLife Studios Toronto", "Warrior Arts Academy", "WAA", "OMHA Mag",
  "Amoi Mag", "Calgary Colts", "Erin Mills Fitness", "Mississauga Training Centre", "Running Room",
  "Toronto Soccer Camp", "Rexall Pharmaceuticals", "Pyramid Hills", "Wadi Degla", "Ancient Sands",
  "Jovians", "Magic Planet", "Sharp", "Gates Developments", "Catalan", "Ceramica Cleopatra",
  "Healthy Planet", "Mivida", "Transcend Coffee", "Lowest Rates", "Swan Lake Cairo Runners", "HDCP",
];

export default function Clients() {
  return (
    <section
      id="credits"
      data-testid="credits-section"
      className="border-t border-white/10 py-14 md:py-16"
    >
      <h2
        data-testid="credits-overline"
        className="mb-8 text-center font-mono text-[10px] font-normal tracking-[0.45em] text-zinc-600"
      >
        SELECTED CREDITS
      </h2>
      <p
        data-testid="clients-honesty-line"
        className="mx-auto mb-12 max-w-2xl text-center font-serif text-lg italic leading-relaxed text-zinc-400 md:text-xl"
      >
        Our directors, creative team, advertising photographers and cinematographers have worked
        on major campaigns around the world — now they are bringing their unique vision to Bite
        films.
      </p>
      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#050505] to-transparent md:w-40" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#050505] to-transparent md:w-40" />
        <div
          data-testid="clients-marquee"
          className="marquee-track flex w-max items-center whitespace-nowrap"
          style={{ animationDuration: "150s" }}
        >
          {[0, 1].map((half) => (
            <div key={half} className="flex items-center" aria-hidden={half === 1}>
              {clients.map((name) => (
                <span key={`${half}-${name}`} className="flex items-center">
                  <span className="cursor-default px-8 font-serif text-xl text-zinc-500 transition-colors duration-300 hover:text-[#E1A730] md:px-10 md:text-2xl">
                    {name}
                  </span>
                  <span aria-hidden="true" className="h-1 w-1 rounded-full bg-zinc-800" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
